import React from 'react';
import { StarField } from './components/StarField';
import { HeroSection } from './components/HeroSection';
import { EmotionalHook } from './components/EmotionalHook';
import { SolutionSection } from './components/SolutionSection';
import { UniqueFeatures } from './components/UniqueFeatures';
import { BenefitsSection } from './components/BenefitsSection';
import { PackageContents } from './components/PackageContents';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-night-sky font-body overflow-x-hidden selection:bg-gold/30 selection:text-white" data-id="element-0">
      <StarField data-id="element-1" />

      <main className="relative z-10 flex flex-col w-full" data-id="element-2">
        <HeroSection data-id="element-3" />
        <EmotionalHook data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <UniqueFeatures data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <PackageContents data-id="element-8" />
        <CTASection data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
    </div>;
}